import React from 'react';

export const GENERATE_ANSWER_SHEET_CONTENT = (
  <span>
    Generate personalized answer sheets that can be used to collect responses
    for print format assessments and uploaded to AP Classroom.
    <a
      href="https://apclassroom.clickhelp.co/articles/#!ap-classroom-user-guide-for-teachers-publication/tch-using-answer-sheets"
      target="_blank"
      rel="noopener noreferrer"
    >
      {' '}
      Learn more.
    </a>
  </span>
);
